import OnboardingRoutesWithProvider from '@leagueplatform/onboarding';
import { Box } from '@leagueplatform/genesis-core';
import { TENANT_ID } from 'common/constants';
import { getFeatureHighlightsContentfulId } from 'common/env';

export const OnboardingFeatureHighlights = ({
  onOnboardingComplete,
}: {
  onOnboardingComplete: (error?: Error) => void;
}) => (
  // The SDK renders the Skip button as a text-only tertiary button. Restyle it
  // to a Secondary/Border Default outlined pill to match the onboarding design.
  <Box
    css={{
      '& button[aria-describedby="onboarding-fh-title"]': {
        borderWidth: '$thin',
        borderStyle: 'solid',
        borderColor: '$secondaryBorderDefault',
        borderRadius: '$pill',
        color: '$secondaryBorderDefault',
        // SDK renders Skip at size="large"; shrink to medium to match the design.
        typography: '$buttonTwo',
        paddingBlockStart: '$half',
        paddingBlockEnd: '$half',
        paddingInlineStart: '$one',
        paddingInlineEnd: '$one',
      },
    }}
  >
    <OnboardingRoutesWithProvider
      contentfulId={getFeatureHighlightsContentfulId()}
      tenantId={TENANT_ID}
      onOnboardingComplete={onOnboardingComplete}
    />
  </Box>
);
